import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/image/importer/imageImporterActions';

export default importerReducers(actions);
